import { themeUi } from '../../themeUi/themeUi';

export const totalPriceFooter = {
  borderTop: `1px solid ${themeUi.semantic.color.border.secondary300}`
};
